import { range } from 'es-toolkit';
import React, { Key } from 'react';
import { Vector3 } from 'three';

import { formatHexColor } from '@paragon/client-tools';
import { Point3D } from '@paragon/three-shared';

import LabelVisual from './LabelVisual';
import MeshLine from './MeshLine';

const axisColors = {
  x: 0xf44242,
  y: 0x42e558,
};
const gridLineColor = 0x555555;

const cellCount = 200;
const width = cellCount * 12;
const halfWidth = width / 2;
const lineCount = cellCount + 1;
const spacing = width / cellCount;

function renderAxisGridLine(vertices: readonly [Point3D, Point3D], key: Key, lineColor = gridLineColor) {
  return <MeshLine lineStart={vertices[0]} lineEnd={vertices[1]} key={key} color={lineColor} thickness={0.1} />;
}

function renderMainGrid() {
  const xLines = range(lineCount).map((index) => {
    const offset = index * spacing - halfWidth;
    if (offset === 0) return null;
    return renderAxisGridLine([new Vector3(offset, -halfWidth, 0), new Vector3(offset, halfWidth, 0)], `xy${offset}`);
  });
  const yLines = range(lineCount).map((index) => {
    const offset = index * spacing - halfWidth;
    // Do not overwrite x axis
    if (offset === 0) return null;
    return renderAxisGridLine([new Vector3(-halfWidth, offset, 0), new Vector3(halfWidth, offset, 0)], `yz${offset}`);
  });
  return (
    <>
      {xLines}
      {yLines}
    </>
  );
}

function renderAxisLines() {
  const xAxis = renderAxisGridLine(
    [new Vector3(-halfWidth, 0, 0), new Vector3(halfWidth, 0, 0)],
    'xAxis',
    axisColors.x,
  );
  const yAxis = renderAxisGridLine(
    [new Vector3(0, -halfWidth, 0), new Vector3(0, halfWidth, 0)],
    'yAxis',
    axisColors.y,
  );

  return (
    <>
      {xAxis}
      {yAxis}
    </>
  );
}

function renderLabels() {
  return (
    <>
      <LabelVisual
        labelText="x"
        position={{ x: -6, y: 2, z: 0 }}
        fontHeight={120}
        color={formatHexColor(axisColors.x)}
        key="xAxis"
      />
      <LabelVisual
        labelText="y"
        position={{ x: -2, y: 6, z: 0 }}
        fontHeight={120}
        color={formatHexColor(axisColors.y)}
        key="yAxis"
      />
    </>
  );
}

export default function ReferenceGridVisual() {
  return (
    <>
      {renderMainGrid()}
      {renderAxisLines()}
      {renderLabels()}
    </>
  );
}
